import { render, staticRenderFns } from "./NCurrencyInput.vue?vue&type=template&id=ac1806b8&scoped=true&"
import script from "./NCurrencyInput.vue?vue&type=script&lang=js&"
export * from "./NCurrencyInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1806b8",
  null
  
)

export default component.exports